import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, Share, X } from "lucide-react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);
  const [visible, setVisible] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (isStandalone()) return; // already installed
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => {
      setInstalled(true);
      setVisible(false);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    // iOS Safari has no beforeinstallprompt — offer manual hint.
    if (isIOS()) setVisible(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setDeferred(null);
      setVisible(false);
    } else if (isIOS()) {
      setShowIosHint(true);
    }
  };

  if (installed || !visible) return null;

  return (
    <div className="tv-reveal tv-delay-5 mt-4 max-w-4xl" data-testid="install-pwa">
      <div className="flex flex-wrap items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-3">
        <Download className="h-5 w-5 shrink-0 text-primary" />
        <p className="mr-auto text-sm text-foreground sm:text-base">
          Pasang aplikasi <span className="font-bold text-primary">Travele</span> di layar HP Anda — akses jadwal lebih cepat, satu ketuk.
        </p>
        <Button
          size="sm"
          className="bg-primary font-bold text-primary-foreground hover:bg-primary/90"
          onClick={handleInstall}
          data-testid="install-pwa-btn"
        >
          <Download className="mr-1 h-4 w-4" /> Install Aplikasi Travele
        </Button>
      </div>

      {showIosHint && (
        <div className="mt-2 flex items-start gap-2 rounded-lg border border-border bg-card px-4 py-3 text-sm text-muted-foreground" data-testid="install-pwa-ios-hint">
          <Share className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          <p className="mr-auto">
            Di Safari iPhone/iPad: ketuk ikon <span className="font-semibold text-foreground">Bagikan</span> lalu pilih{" "}
            <span className="font-semibold text-foreground">"Tambah ke Layar Utama"</span> untuk memasang Travele.
          </p>
          <button type="button" onClick={() => setShowIosHint(false)} className="text-muted-foreground hover:text-foreground" aria-label="Tutup">
            <X className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  );
};
